// React imports
import { Col, Row, Form, Button } from "antd"
import BugReportForm from "Components/forms/bugReportForm"
import React from "react"
import { Store } from "antd/lib/form/interface"
import { NotificationService, UserService } from "Shared/services"
import { sendBugReport } from "Shared/store/actions/bugReport/bugReport.action"
import { useDispatch } from "react-redux"
import { NotificationTypeEnum } from "Shared/services/notification.service"
import { useHistory } from "react-router-dom"
import { useTranslation } from "react-i18next"

// Redux imports

// Component imports

export const BugReport: React.FC = () => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const history = useHistory()

    const [formInstance] = Form.useForm()

    const { email } = UserService.getLoggedInUserProfile()

    const handleSubmit = ({ message }: Store) => {
        sendBugReport({ email, message })(dispatch)
            .then(() => {
                NotificationService.send(NotificationTypeEnum.SUCCESS, "Bug Report Sent", "Your report has been sent, thank you.")

                formInstance.resetFields()
            })
            .catch((err) => {
                NotificationService.showErrorNotificationBasedOnResponseError(err, "Error")
            })
    }

    return (
        <div className="bg-primary flex items-center justify-center min-h-screen h-full w-full">
            <Row className="w-full p-10">
                <Col span={5} sm={{ span: 12, offset: 6 }} md={{ span: 8, offset: 8 }} lg={{ span: 6, offset: 9 }}>
                    <div className="flex w-full flex-col items-center justify-center">
                        <div>
                            <img src={"./images/logo.svg"} style={{ height: "36px" }} alt={"FINWAY"} />
                        </div>
                        <div className="bg-white w-full rounded p-32 shadow mb-32 mt-32 md:mt-40">
                            <BugReportForm formInstance={formInstance} handleSubmit={handleSubmit} />
                            <div className="btn-wrapper">
                                <Button className="btn-success-light" onClick={formInstance.submit}>
                                    {t("action:bug_report.submit")}
                                </Button>
                            </div>
                        </div>
                    </div>
                </Col>
            </Row>
        </div>
    )
}

export default BugReport
